import { mapGetters } from 'vuex';
import mvtNearby from '@/common/components/mvtnearby/mvt-nearby.vue';
import lazyCarouselCheckMixin from '@/common/mixins/lazycarouselcheck';
import urlMixin from '@/common/mixins/url.js';
import guideArticleCard from '@/guide/components/guidearticlecard/guidearticlecard.vue';
import guideArticleContent from '@/guide/components/guidearticlecontent/guide-articlecontent.vue';
import guideArticleListingSeo from '@/guide/components/guidearticleseo/guide-listingseo.vue';
import guideArticleNearBySeo from '@/guide/components/guidearticleseo/guide-nearbyseo.vue';
import guideAuthorInfo from '@/guide/components/guideauthorinfo/guide-authorinfo.vue';
import guideNavigation from '@/guide/components/guidenavigation/guide-navigation.vue';
import guideWelcome from '@/guide/components/guidewelcome/guide-welcome.vue';
import cardSection from '@/market-trends/components/cardsection/card-section.vue';
import mvtLazyload from '@/common/components/mvtlazyload/mvt-lazyload.vue';

export default {
    name: 'articleThemeTwo',
    props: ['type'],
    components: {
        guideWelcome,
        guideAuthorInfo,
        guideNavigation,
        guideArticleContent,
        guideArticleCard,
        guideArticleNearBySeo,
        guideArticleListingSeo,
        cardSection,
        mvtNearby,
        urlMixin,
        mvtLazyload,
    },
    mixins: [lazyCarouselCheckMixin],
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('guide', ['guide', 'relatedArticleCards', 'relatedArticleLinks']),
        path() {
            let path = urlMixin.methods.generateMapSearchUrl('', {
                type: 'city',
                cityName: this.glb.geo.city,
                stateCode: this.glb.geo.stateCode,
                filterArray: ['condo'],
            });
            return {
                condo: (path.filteredUrlObj && path.filteredUrlObj.condo) || '',
                city: (this.glb.geo && this.glb.geo.cityPath) || '',
            };
        },
    },
    methods: {
        completed() {
            this.$refs.lazyloadNearby && this.$refs.lazyloadNearby.ready();
            this.$refs.lazyloadNearbyCondos && this.$refs.lazyloadNearbyCondos.ready();
        },
    },
};
